<template>
    <LayoutBase>
        <div class="full-height grid">
            <account-sidebar></account-sidebar>

            <div id="content-wrapper" class="app-position">
                <div class="container-fluid">
                    <div class="row no-gutters">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <div class="article-wrapper">
                                <alert v-if="alert.copy" :type="alert.type" :title="alert.title" :copy="alert.copy"></alert>
                                
                                <div class="panel">
                                    <header>
                                        <h1>Invite Team Members</h1>
                                    </header>
                                    
                                    <p>
                                        For each person that you want to add please enter their email address, name, job title, phone and mobile - all separated by commas. Example format below:
                                        <br><br>
                                        john.smith@company.com, John Smith, Managing Director, 0121 123456, 07777777777
                                        <br><br>
                                        Use a new line per new team member. You can send up to 100 invitations at a time.
                                    </p>

                                    <div class="form">
                                        <div class="form__group">
                                            <div class="placeholder-wrapper" style="position: relative;">
                                                <div v-if="!users" class="placeholder" style="position: absolute; padding: 12px 16px; white-space: pre-wrap; top: 0px; left: 0px; z-index: 9; pointer-events: none;">john.smith@company.com, John Smith, Managing Director, 0121 123456, 07777777777
                                                </div>
                                                <textarea class="form__control" rows="20" v-model="users"></textarea>
                                            </div>
                                        </div>
                                        <div class="form__group">
                                            <button class="btn btn-primary" v-on:click.stop.prevent="saveSettings">Import these members</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    import LayoutBase from '../../layouts/LayoutBase';
    export default {
        components: {
            LayoutBase
        },
        data () {
            return {
                alert: {
                    type: null,
                    title: null,
                    copy: null
                },
                users: null,
            }
        },
        mounted() {
            //this.getUsers();
        },
        methods: {
            saveSettings() {
                axios.post('/api/account/users/invite', {users: this.users}).then((response) => {
                    this.users = response.data;
                }).catch(error => {
                    window.scrollTo(0, 0);
                    this.alert.type = 'error';
                    this.alert.copy = error.response.data;
                });
            },
        },
        // Guard to protect route from none admins
        beforeRouteEnter(to, from, next){
            if (!window.user_can.admin) next('/')
            else next()
        }
    }
</script>

<style lang="scss">
</style>